
// import assert from 'assert';
import {useState} from 'react';
import classNames from 'classnames';
import {
    Avatar as LuffyAvatar,
    AvatarProps as LuffyAvatarProps,
} from '@baidu/luffy-comp-avatar';

import Icon from '../Icon';
import {concatImgSrc} from '@/utils/avatarUtils';
import {DefaultAvatarSvg} from '@/icons';
import emailGroupDefaultAvatar from '@/assets/img/emailGroupDefaultAvatar.png';
import styles from './index.module.scss';

const AVATAR_COLOR = [
    '#f4c327',
    '#71d381',
    '#389af2',
    '#bd6de2',
    '#f79f57',
    '#f96e75',
    '#6ec7cc',
    '#737ee0',
    '#b4d344',
    '#9eb6d8',
];
export enum AvatarSize {
    XSS = 'xss',
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
    SS = 'ss'
}

export interface AvatarProps extends LuffyAvatarProps {
    userGuid?: string;
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    repositoryTemplateId?: string;
    uploadTime?: number;
    gid?: number | string | undefined;
    defaultText?: string;
    emailGroup?: boolean;
}

// eslint-disable-next-line complexity
const Avatar = (props: AvatarProps) => {
    const {
        children,
        userGuid,
        spaceGuid,
        groupGuid,
        repositoryGuid,
        repositoryTemplateId,
        uploadTime,
        className,
        size,
        src,
        gid,
        defaultText,
        emailGroup = false,
        ...avatarProps
    } = props;
    const [loadError, setLoadError] = useState(false);

    const luffyAvatarProps: LuffyAvatarProps = avatarProps as LuffyAvatarProps;
    const isSpaceOrGroupAvatar = !userGuid && spaceGuid && groupGuid;
    if (emailGroup) {
        return (
            <div
                className={classNames(
                    styles.container,
                    styles[size],
                    className
                )}
            >
                <img className={styles.img} src={emailGroupDefaultAvatar} alt="" />
            </div>
        );
    }

    if (loadError) {
        return (
            <LuffyAvatar
                {...luffyAvatarProps}
                size={size}
                src={src}
                className={classNames(styles.errorAvatar, className)}
            >
                {gid && (
                    <Avatar
                        style={gid ? {backgroundColor: AVATAR_COLOR[+(gid) % 10]} : {}}
                        className={styles.errorIcon}
                        size={size}
                    >
                        {defaultText && defaultText[0]}
                    </Avatar>
                )}
                {!gid && (
                    <Icon
                        className={classNames(
                            styles.errorIcon,
                            isSpaceOrGroupAvatar && styles.square,
                            isSpaceOrGroupAvatar && 'square'
                        )}
                        svg={DefaultAvatarSvg}
                        noSpace
                    />
                )}
            </LuffyAvatar>
        );
    }

    function isUseLuffyAvatar() {
        return (!userGuid
            && !spaceGuid && !groupGuid && !repositoryGuid
            && !repositoryTemplateId
            && !gid);
    }

    if (isUseLuffyAvatar()) {

        return (
            <LuffyAvatar
                {...luffyAvatarProps}
                size={size}
                src={src}
                className={className}
            >
                {children}
            </LuffyAvatar>
        );
    }


    let avatarSrc = src;

    avatarSrc = concatImgSrc(
        userGuid,
        spaceGuid,
        groupGuid,
        repositoryGuid,
        uploadTime,
        repositoryTemplateId,
        gid
    );

    function handleLoadError() {
        setLoadError(true);
    }

    return (
        <div
            className={classNames(
                styles.container,
                styles[size],
                className,
                isSpaceOrGroupAvatar && styles.square,
                isSpaceOrGroupAvatar && 'square'
            )}
        >
            <img
                className={classNames(
                    styles.img,
                    isSpaceOrGroupAvatar && styles.square,
                    isSpaceOrGroupAvatar && 'square'
                )}
                src={avatarSrc}
                onError={handleLoadError}
            />
        </div>
    );
};

export default Avatar;
